import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import isEqual from 'lodash/isEqual';

class LocalizeComponent extends React.Component {
  static __singletonRef = React.createRef;
  static getInstance() {
    return LocalizeComponent.__singletonRef;
  }

  constructor() {
    super();
    LocalizeComponent.__singletonRef = this;
  }

  shouldComponentUpdate(nextProps, nextState) {
    let isEqualProps = !isEqual(this.props, nextProps);
    let isEqualStates = !isEqual(this.state, nextState);
    return isEqualProps || isEqualStates;
  }

  formatMessage(...args) {
    const { intl } = this.props;
    return intl.formatMessage(...args);
  }
  render() {
    return false;
  }
}

LocalizeComponent.propTypes = {
  intl: intlShape.isRequired
};

export const IntlReact = injectIntl(LocalizeComponent);

export default (...args) => {
  return args[0].defaultMessage; //
  // return LocalizeComponent.getInstance().formatMessage(...args);
};
